<template>
    <div v-if="holder">
        <v-card id="edit">
            <v-container fluid>
                <p class="headline">修改客戶資料</p>
                <v-form ref="form" lazy-validation>
                    <v-row class="mb-2">
                        <v-col :lg="3">
                            <v-text-field
                            v-model="holder.name"
                            :rules="[(v) => !!v || '請填寫姓名']"
                            label="姓名"
                            required
                            ></v-text-field>
                        </v-col>
                        <v-col :lg="3">
                            <v-text-field
                            v-model="holder.phone"
                            label="聯絡電話"
                            ></v-text-field>
                        </v-col>
                        <v-col :lg="3">
                            <salesman-combo
                                v-model="holder.salesman"
                                label="業務員姓名"
                                :rules="[(v) => !((v === null) || (v.name.trim()=='')) || '請填寫業務員名稱']">
                            </salesman-combo>
                        </v-col>
                        <v-col :lg="3">
                            <v-select
                                v-model="holder.level"
                                :items="level_items"
                                label="客戶等級"
                            ></v-select>
                        </v-col>
                    </v-row>
                    <v-row class="mb-2">
                        <v-col :lg="3"> 
                            <v-radio-group 
                            v-model="holder.sex" 
                            row label='性別'
                            :rules="[(v) => !!v || '請填寫性別']">
                            <v-radio label='男性' value='male'></v-radio>
                            <v-radio label='女性' value='female'></v-radio>
                            </v-radio-group>
                        </v-col>
                        <v-col :lg="3">
                            <v-menu
                            v-model="birthday_menu"
                            :close-on-content-click="false"
                            :nudge-right="40"
                            transition="scale-transition"
                            offset-y
                            min-width="auto"
                            >
                            <template v-slot:activator="{ on, attrs }">
                                <v-text-field
                                v-model="holder.birthday"
                                :rules="[(v) => !!v || '請填寫出生日期']"
                                label="出生日期"
                                prepend-icon="mdi-calendar"
                                readonly
                                v-bind="attrs"
                                v-on="on"
                                ></v-text-field>
                            </template>
                            <v-date-picker
                                v-model="holder.birthday"
                                @input="birthday_menu = false"
                                no-title
                            ></v-date-picker>
                            </v-menu>
                        </v-col>
                        <v-col :lg="3">
                            <v-text-field
                            v-model="holder.email"
                            :rules="[checkEmail]"
                            label="Email信箱"
                            ></v-text-field>
                        </v-col>
                        <v-col :lg="3">
                            <v-text-field
                            v-model="holder.eng_name"
                            label="英文姓名"
                            ></v-text-field>
                        </v-col>
                    </v-row>
                    <v-row class="mb-2">
                        <v-col :lg="4">
                            <city-select v-model="selectCity" :options="cities" 
                                :labelName="cityLabelName" 
                                :checkRules="formRules.cityRules"/>
                        </v-col>
                        <v-col :lg="4">
                            <city-select v-model="selectTownship" :options="townships" 
                                :labelName="townshipLabelName" 
                                :checkRules="formRules.townshipRules"/>
                        </v-col>
                        <v-col :lg="4">
                            <v-text-field
                            v-model="holder.address"
                            :rules="[(v) => !!v || '請填寫詳細地址']"
                            label="保單登記地址-詳細地址"
                            required
                            ></v-text-field>
                        </v-col>
                    </v-row>
                    <v-row class="mb-2">
                        <v-col>
                            <v-btn depressed  color="secondary" @click="copyAddress">複製保單登記地址到聯絡地址
                            </v-btn>
                        </v-col>
                    </v-row>
                    <v-row class="mb-2">
                        <v-col :lg="4">
                            <city-select v-model="selectConnectionCity" :options="connectionCities" 
                                :labelName="connectionCityLabelName"/>
                        </v-col>
                        <v-col :lg="4">
                            <city-select v-model="selectConnectionTownship" :options="connectionTownships" 
                                :labelName="connectionTownshipLabelName"/>
                        </v-col>
                        <v-col :lg="4">
                            <v-text-field
                            v-model="holder.connection_address"
                            label="聯絡地址-詳細地址"
                            ></v-text-field>
                        </v-col>
                    </v-row>
                    <v-divider class="my-5"></v-divider>
                    <v-btn color="success" small class="mr-2" @click="updateHolder">
                        更新
                    </v-btn>
                    <v-btn color="primary" small @click="toList">
                        回列表
                    </v-btn>
                </v-form>
                <p class="mt-3">{{ message }}</p>
                <holder-visit-record :holder_id="holder.id">
                </holder-visit-record>
            </v-container>
        </v-card>
    </div>
    <div v-else>
        <p>請檢查客戶資料...</p>
    </div>
</template>
<script>
import HolderVisitRecord from '../../components/HolderVisitRecord'
import CitySelect from '../../components/CitySelect'
import citydata from '../../services/citiesdata.json'
import HolderService from '../../services/HolderService'
import SalesmanCombo from '../../components/SalesmanCombo'

export default {
    name: "holder-detail",
    components: {
        CitySelect,
        HolderVisitRecord,
        SalesmanCombo,
    },
    data(){
        return {
            holder: null,
            level_items: ['','A','B','C','D'],
            message: "",
            birthday_menu: false,
            selectCity: "",
            selectTownship: "",
            cityLabelName: "保單登記地址-縣市",
            townshipLabelName: "保單登記地址-區域",

            cityIdx: 0, //城市選擇
            townshipIdx: 0,
            
            selectConnectionCity: "",
            selectConnectionTownship: "",
            connectionCityLabelName: "聯絡地址-縣市",
            connectionTownshipLabelName: "聯絡地址-區域/鄉鎮",
            connectionCityIdx: 0, //城市選擇
            connectionTownshipIdx: 0,
            formRules:{
                cityRules: [
                    v => !!v || '請選擇縣市'
                ],
                townshipRules: [
                    v => !!v || '請選擇區域/鄉鎮'
                ],
            }
        }
    },
    methods: {
        checkEmail(value){
            //有填寫才做檢查，清空不檢查
            if ((value === null) || (value === undefined) || (value.length === 0)){
                return true;
            } else {
                if (/.+@.+\..+/.test(value)) {
                    return true;
                } else {
                    return '請確認E-mail郵件信箱格式';
                }
            }
        },
        copyAddress(){
            //this.holder.connection_city = this.holder.city;
            this.selectConnectionCity = this.holder.city;
            //this.holder.connection_township = this.holder.township;
            this.selectConnectionTownship = this.holder.township;
            this.holder.connection_address = this.holder.address;
        },
        getHolder(id){
            HolderService.get(id)
                .then((response) =>{
                    this.holder = response.item;
                    //console.log(JSON.stringify(response.data));
                    this.message = response.message;
                    this.selectCity = this.holder.city;
                    this.selectTownship = this.holder.township;
                    this.selectConnectionCity = this.holder.connection_city;
                    this.selectConnectionTownship = this.holder.connection_township;
                })
                .catch((e) =>{
                    console.log(e);
                });
        },
        
        updateHolder(){
            if (this.$refs.form.validate()){ //檢查欄位
                var updateData = {  holder: this.holder };
                //console.log(JSON.stringify(updateData),'updateHolder')
                HolderService.update(this.holder.id, updateData)
                    .then((response) => {
                        //console.log(JSON.stringify(response));
                        this.message = response.message;
                    })
                    .catch((e) =>{
                        console.log(e);
                    });
            }
        },
        toList(){
            this.$router.push({ name: "holder-list"}); 
        }
    },
    mounted(){
        this.message="";
        this.getHolder(this.$route.params.id);

    },
    computed:{
        cities: function(){
            return citydata;
        },
        townships: function() {
            if (this.cityIdx == -1) return [];
            return this.cities[this.cityIdx].areas;
        },
        connectionCities: function(){
            return citydata;
        },
        connectionTownships: function() {
            if (this.connectionCityIdx == -1) return [];
            return this.connectionCities[this.connectionCityIdx].areas;
        }
    },
    watch: {
        selectCity: function() { //下拉選單異動，聯動鄉鎮市區資料
            this.townshipIdx = -1;
            if (this.selectCity == null) {
                this.cityIdx = -1;
                this.holder.city = null;
                this.selectTownship = null;
                this.holder.township = null;
            } else {
                var filter = (element) => element.name === this.selectCity;
                this.cityIdx = this.cities.findIndex(filter);
                this.holder.city = this.selectCity;
            }
        },

        selectTownship: function(){ //下拉選單異動，異動相關資料
            this.holder.township = this.selectTownship;
        },

        selectConnectionCity: function() { //下拉選單異動，聯動鄉鎮市區資料
            this.connectionTownshipIdx = -1;
            if (this.selectConnectionCity == null) {
                this.connectionCityIdx = -1;
                this.holder.connection_city = null;
                this.selectConnectionTownship = null;
                this.holder.connection_township = null;
            } else {
                var filter = (element) => element.name === this.selectConnectionCity;
                this.connectionCityIdx = this.connectionCities.findIndex(filter);
                this.holder.connection_city = this.selectConnectionCity;
            }
        },

        selectConnectionTownship: function(){ //下拉選單異動，異動相關資料
            this.holder.connection_township = this.selectConnectionTownship;
        }
    }
}
</script>
<style scoped>

</style>